import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Card, CardBody, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFormValues } from 'redux-form';
import * as submissionFormActions from 'actions/submissionFormActions';
import * as currentUserActions from 'actions/currentUserActions';
import * as finalWizardActions from 'actions/finalWizardActions';
import actionTypes from 'constants/currentUserConstants';

class ResetPasswordForm extends Component {
  static propTypes = {
    currentUser: ImmutablePropTypes.map.isRequired,
    formValues: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired,
    saveDraft: PropTypes.func.isRequired,
    goToFinalStep: PropTypes.func.isRequired,
    formIsLoading: PropTypes.bool.isRequired,
  };

  onCancel = () => this.props.goToFinalStep("password");

  resetPassword = () => {
    this.props.saveDraft('preview');
    this.props.resetPassword(this.props.formValues.email);
    this.props.goToFinalStep("password");
  };

  render() {
    const { formValues, currentUser, formIsLoading } = this.props;
    const isLoading = formIsLoading || currentUser.get('isLoading');

    return (
      <Card>
        <div className="card-header">
          <h4>Forgot your password?</h4>
        </div>
        <CardBody>
          <p>
            We can send an email to <strong>{formValues.email}</strong> to help reset your password.
          </p>
          <Button onClick={this.resetPassword} disabled={isLoading} block color="primary">
            {isLoading ? 'Please wait...' : 'Send password reset email'}
          </Button>
        </CardBody>
        <div className="row">
          <div className="col-12 text-right">
            <Button onClick={this.onCancel} color="link">Cancel</Button>
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  formIsLoading: state.submissionForm.get('isLoading'),
  formValues: getFormValues('eventSubmission')(state),
  currentUser: state.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch),
  ...bindActionCreators(currentUserActions, dispatch),
  ...bindActionCreators(finalWizardActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPasswordForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/final/ResetPasswordForm.jsx